import { createSlice } from '@reduxjs/toolkit';
import { getVendorTransactions } from '../../actions/Transaction/transactionVendorActions';
import { actionTypes } from '../../actionTypes';
// redux state
const initialState = {
  transactionsVendor: undefined,
  error: '',
  isLoading: false,
};

// slice or reducer
const VendorTransactions = createSlice({
  name: 'VendorTransactions',
  initialState,
  // normal reducers
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
  },
  // async reducers
  extraReducers: (builder) => {
    caseVendorTransactions(builder, getVendorTransactions);
  },
});
export default VendorTransactions.reducer;

const caseVendorTransactions = (builder, action) => {
  builder.addCase(action.pending, (state) => {
    state.isLoading = true;
  });
  handleAllFulfillCases(builder, action);

  builder.addCase(action.rejected, (state) => {
    state.isLoading = false;
  });
};

const handleAllFulfillCases = (builder, action) => {
  builder.addCase(action.fulfilled, (state, action) => {
    // state updated in fulfilled state

    if (action.type.includes(actionTypes.GET_VENDOR_TRANSACTION)) {
      state.isLoading = false;
      state.transactionsVendor = action.payload;
    }
  });
};
